// Web Audio sfx, ludo pattern: each play creates a fresh BufferSource → parallel
// playback. Files load with try-catch and are optional (game runs silent if a
// file fails). Safari: resume() on first gesture; guard suspended in play().
import startUrl  from '../sfx/start.wav';
import shootUrl  from '../sfx/shoot.wav';
import bounceUrl from '../sfx/bounce.wav';
import popUrl    from '../sfx/pop.mp3';
import dropUrl   from '../sfx/drop.wav';
import growUrl   from '../sfx/grow.wav';
import loseUrl   from '../sfx/lose.wav';

const actx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
const buffers = new Map<string, AudioBuffer>();

export function resumeAudio(): void { if (actx.state === 'suspended') actx.resume(); }

async function load(url: string): Promise<void> {
  try {
    const resp = await fetch(url);
    const arr = await resp.arrayBuffer();
    buffers.set(url, await actx.decodeAudioData(arr));
  } catch { /* optional — stay silent */ }
}

function play(url: string, vol = 1): void {
  if (actx.state === 'suspended') return;
  const buf = buffers.get(url);
  if (!buf) return;
  try {
    const src = actx.createBufferSource();
    const gain = actx.createGain();
    gain.gain.value = vol;
    src.buffer = buf;
    src.connect(gain);
    gain.connect(actx.destination);
    src.start();
  } catch { /* ignore */ }
}

export function preloadAudio(): void {
  [startUrl, shootUrl, bounceUrl, popUrl, dropUrl, growUrl, loseUrl].forEach(load);
}

export const playStart  = () => play(startUrl, 0.6);
export const playShoot  = () => play(shootUrl, 0.6);
export const playBounce = () => play(bounceUrl, 0.4);
export const playPop    = () => play(popUrl, 0.7);
export const playDrop   = () => play(dropUrl, 0.7);
export const playGrow   = () => play(growUrl, 0.6);
export const playLose   = () => play(loseUrl, 0.8);
